<span class="ui-copyable" [class.ui-copyable--big]="size === 'big'" [class.ui-copyable--has-value]="hasValue">
  <span class="ui-copyable__content"><ng-content></ng-content></span>

  <button
    *ngIf="hasValue"
    type="button"
    class="ui-copyable__btn"
    [class.ui-copyable__btn--copied]="copied"
    [matTooltip]="tooltipText"
    [matTooltipPosition]="tooltipPosition"
    #tooltip="matTooltip"
    [attr.aria-label]="tooltipText"
    (click)="copy($event)">
    <ui-svg-icon [svgIcon]="copied ? 'check-cc' : 'copy'" [size]="iconSize"></ui-svg-icon>
  </button>
</span>
